/**
 * Defines actions related to view and update of the users details.
 */
import {
  SET_USERS_ERROR_MESSAGES, CLEAR_HELPER_TEXT_MESSAGES, CLEAR_ERROR_MESSAGE, UPDATE_PROFILE_DETAILS, CLOSE_TOAST_MESSAGE, GET_COUNTRIES,
} from 'constants/ActionTypes';

export const setErrorMessages = (eventId, errorMsgs) => ({
  type: SET_USERS_ERROR_MESSAGES,
  eventId,
  errorMsgs,
});

export const clearHelperTextMessages = () => ({
  type: CLEAR_HELPER_TEXT_MESSAGES,
});

export const clearErrorMessage = (fieldId) => ({
  type: CLEAR_ERROR_MESSAGE,
  fieldId,
});

export const updateProfileDetails = (requestBody) => ({
  type: UPDATE_PROFILE_DETAILS,
  requestBody,
});

export const closeToastMessage = () => ({
  type: CLOSE_TOAST_MESSAGE,
});

export const getCountries = () => ({
  type: GET_COUNTRIES,
});
